import component from './src/scrollbar';
export default {
  install(Vue){
    Vue.component(component.name, component);
  }
}



// WEBPACK FOOTER //
// ./src/framework/components/base/scrollbar/index.js